import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Video, Star, ShieldCheck, CheckCircle2 } from 'lucide-react';
import { professionals } from '../../data/mockData';
export function VideoConsultFlow() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [specialty, setSpecialty] = useState('');
  const [selectedDoctor, setSelectedDoctor] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const specialties = ['Any Available Doctor', 'General Doctor', 'Pediatrics', 'Mental Health', 'Gynecology'];
  const handleSelectSpecialty = (spec: string) => {
    setSpecialty(spec);
    setStep(2);
    setLoading(true);
    setTimeout(() => setLoading(false), 1000);
  };
  const handlePayment = () => {
    setStep(5);
    setTimeout(() => navigate('/video-call'), 3000);
  };
  const availableDoctors = professionals.filter(p => p.modes.includes('Video'));
  return <div className="min-h-screen bg-slate-900 text-white flex flex-col" data-id="element-828">
      <div className="px-6 pt-12 pb-4 sticky top-0 z-10" data-id="element-829">
        <div className="flex items-center gap-3 mb-4" data-id="element-830">
          <button onClick={() => step > 1 && step < 5 ? setStep(step - 1) : navigate(-1)} className="p-2 -ml-2 hover:bg-white/10 rounded-full" data-id="element-831">
            <ArrowLeft className="w-6 h-6 text-white" data-id="element-832" />
          </button>
          <h1 className="text-xl font-bold" data-id="element-833">Instant Video Consult</h1>
        </div>
      </div>

      <div className="p-6 flex-1 overflow-y-auto" data-id="element-834">
        {step === 1 && <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-4" data-id="element-835">
            <h2 className="font-semibold text-slate-300 mb-4" data-id="element-836">
              What do you need help with?
            </h2>
            <div className="space-y-3" data-id="element-837">
              {specialties.map(spec => <button key={spec} onClick={() => handleSelectSpecialty(spec)} className="w-full bg-slate-800 p-4 rounded-xl border border-slate-700 text-left font-medium hover:bg-slate-700 transition-colors flex items-center justify-between" data-id="element-838">
                  {spec}
                  {spec === 'Any Available Doctor' && <span className="bg-green-500/20 text-green-400 text-xs px-2 py-1 rounded-md" data-id="element-839">
                      Fastest
                    </span>}
                </button>)}
            </div>
          </motion.div>}

        {step === 2 && <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-4" data-id="element-840">
            <h2 className="font-semibold text-slate-300 mb-4" data-id="element-841">Available Now</h2>
            {loading ? <div className="space-y-4" data-id="element-842">
                {[1, 2].map(i => <div key={i} className="bg-slate-800 p-4 rounded-2xl animate-pulse h-32" data-id="element-843" />)}
              </div> : availableDoctors.map(doc => <div key={doc.id} className="bg-slate-800 rounded-2xl p-4 border border-slate-700" data-id="element-844">
                  <div className="flex space-x-4" data-id="element-845">
                    <div className="relative" data-id="element-846">
                      <img src={doc.image} className="w-16 h-16 rounded-full object-cover" data-id="element-847" />
                      <div className="absolute bottom-0 right-0 w-4 h-4 bg-green-500 border-2 border-slate-800 rounded-full" data-id="element-848"></div>
                    </div>
                    <div className="flex-1" data-id="element-849">
                      <div className="flex items-center" data-id="element-850">
                        <h3 className="font-bold text-base" data-id="element-851">{doc.name}</h3>
                        {doc.verified && <ShieldCheck size={16} className="text-blue-400 ml-1" data-id="element-852" />}
                      </div>
                      <p className="text-sm text-slate-400" data-id="element-853">{doc.specialty}</p>
                      <div className="flex items-center mt-1 text-xs text-slate-400" data-id="element-854">
                        <Star size={12} className="text-amber-400 fill-current mr-1" data-id="element-855" />{' '}
                        {doc.rating}
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 pt-4 border-t border-slate-700 flex items-center justify-between" data-id="element-856">
                    <span className="text-sm font-bold" data-id="element-857">
                      ₦{doc.fee.toLocaleString()}
                    </span>
                    <button onClick={() => {
              setSelectedDoctor(doc);
              setStep(3);
            }} className="bg-indigo-600 text-white text-sm font-semibold px-5 py-2 rounded-xl hover:bg-indigo-700" data-id="element-858">
                      Connect
                    </button>
                  </div>
                </div>)}
          </motion.div>}

        {step === 3 && selectedDoctor && <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-6" data-id="element-859">
            <h2 className="text-xl font-bold text-center" data-id="element-860">Ready to connect?</h2>
            <div className="bg-slate-800 rounded-2xl border border-slate-700 p-4 space-y-3" data-id="element-861">
              <div className="flex justify-between text-sm" data-id="element-862">
                <span className="text-slate-400" data-id="element-863">Doctor</span>
                <span className="font-medium" data-id="element-864">{selectedDoctor.name}</span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-865">
                <span className="text-slate-400" data-id="element-866">Time</span>
                <span className="font-medium text-green-400" data-id="element-867">
                  Starting immediately
                </span>
              </div>
              <div className="pt-3 border-t border-slate-700 flex justify-between font-bold text-lg" data-id="element-868">
                <span data-id="element-869">Total Fee</span>
                <span data-id="element-870">₦{selectedDoctor.fee.toLocaleString()}</span>
              </div>
            </div>
            <button onClick={() => setStep(4)} className="w-full bg-indigo-600 text-white py-3.5 rounded-xl font-semibold text-lg hover:bg-indigo-700" data-id="element-871">
              Continue to Payment
            </button>
          </motion.div>}

        {step === 4 && selectedDoctor && <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-6" data-id="element-872">
            <h2 className="text-xl font-bold" data-id="element-873">Payment</h2>
            <div className="bg-slate-800 p-6 rounded-2xl text-center" data-id="element-874">
              <p className="text-slate-400 text-sm mb-1" data-id="element-875">Amount due</p>
              <h2 className="text-4xl font-bold mb-4" data-id="element-876">
                ₦{selectedDoctor.fee.toLocaleString()}
              </h2>
            </div>
            <button onClick={handlePayment} className="w-full bg-indigo-600 text-white py-3.5 rounded-xl font-semibold text-lg hover:bg-indigo-700" data-id="element-877">
              Pay Securely
            </button>
          </motion.div>}

        {step === 5 && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="flex flex-col items-center justify-center h-full text-center py-20" data-id="element-878">
            <div className="relative w-24 h-24 mb-8" data-id="element-879">
              <div className="absolute inset-0 bg-indigo-500/30 rounded-full animate-ping" data-id="element-880"></div>
              <div className="relative w-full h-full bg-indigo-600 rounded-full flex items-center justify-center" data-id="element-881">
                <Video className="w-10 h-10 text-white" data-id="element-882" />
              </div>
            </div>
            <h2 className="text-xl font-bold mb-4" data-id="element-883">
              Connecting to {selectedDoctor?.name}...
            </h2>
            <div className="space-y-3 w-full max-w-xs" data-id="element-884">
              <div className="flex items-center justify-between bg-slate-800 p-3 rounded-xl" data-id="element-885">
                <span className="text-sm" data-id="element-886">Camera Check</span>
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-887" />
              </div>
              <div className="flex items-center justify-between bg-slate-800 p-3 rounded-xl" data-id="element-888">
                <span className="text-sm" data-id="element-889">Microphone Check</span>
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-890" />
              </div>
            </div>
          </motion.div>}
      </div>
    </div>;
}